import {
  contractsSS,
  ubicationsSS,
  usersSS,
  getRequestsService,
  getUbicationByUbicationType,
  getEquipamentTower
} from '../../../../../services/serviceRequest';
import {
  getServicesWell,
  supplierSS,
  getTeams,
  getServices
} from '../../../../../services/yclickMaster';

export const fetchDataUbication = async (value) => {
  if (value.length < 3) return null;
  const ubicacion = await ubicationsSS(value);

  return ubicacion;
};

export const fetchDataServicios = async (value) => {
  if (value.length < 3) return null;
  const servicios = await getServicesWell(value);

  return servicios;
};

export const fetchDataProveedores = async (value) => {
  if (value.length < 3) return null;
  const proveedores = await supplierSS(value);

  return proveedores;
};

export const fetchDataContratos = async (value) => {
  if (value.length < 3) return null;
  const contratos = await contractsSS(value);

  return contratos;
};

export const fetchDataUsuarios = async (value) => {
  if (value.length < 3) return null;
  const usuarios = await usersSS(value);

  return usuarios;
};

export const fetchDataTeam = async (value) => {
  if (value.length < 3) return null;
  const teams = await getTeams(value);

  return teams;
};

export const fetchServices = async (value) => {
  if (value.length < 3) return null;
  const services = await getServices(value);

  return services;
};

export const fetchRequestsService = async (value) => {
  if (value.length < 3) return null;
  const services = await getRequestsService(value);

  return services;
};

export const fetchDataUbicationByUbicationType = async ({ value, typeUbication }) => {
  if (value.length < 3) return null;
  const ubicacion = await getUbicationByUbicationType({ value, typeUbication });

  return ubicacion;
};

export const fetchEquipamentTower = async ({ value, typeUbication }) => {
  if (value.length < 3) return null;
  const equipamentTower = await getEquipamentTower({ value, typeUbication });

  return equipamentTower;
};
